module.exports = __webpack_public_path__ + "static/05-3045a8f3f408ef4157ec1ff819fd2a8c.jpg";